import React from "react";

import {
  ContactWrapperStyle,
  ModalWrapperBorder,
  ModalWrapperSteps
} from "./ModalWrapperStyles";
import ContactStep1 from "./ContactStep1";
import ContactStep2 from "./ContactStep2";
import ContactStep3 from "./ContactStep3";
import { ThemeContext } from "../../containers/ThemeContext";

class ContactWrapper extends React.Component {
  state = {
    step: 1,
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    checkbox: false,
    typeOfContact: "phone"
  };

  nextStep = () => {
    if (this.state.step === 3) {
      return this.props.hideModalContact() || this.context.hideModalContact();
    }

    const newStep = this.state.step + 1;
    this.setState({
      step: newStep
    });
  };

  onChange = (fieldName, fieldValue) => {
    this.setState(
      {
        [fieldName]: fieldValue
      },
      () => {
        if (this.props.saveCalcData) {
          this.props.saveCalcData(this.state);
        }
      }
    );
  };

  render() {
    const { step } = this.state;
    const stepsDesc = ["Twoje dane", "Typ kontaktu", "Gotowe!"];

    return (
      <ContactWrapperStyle>
        <ModalWrapperBorder contact={true}>
          <ModalWrapperSteps>
            {stepsDesc.map((stepDesc, idx) => {
              const currentStep = ++idx;
              return (
                <span
                  className={this.state.step === currentStep ? "active" : ""}
                >{`0${currentStep}. ${stepDesc}`}</span>
              );
            })}
          </ModalWrapperSteps>
          {step === 1 && (
            <ContactStep1 values={this.state} onChange={this.onChange} />
          )}
          {step === 2 && (
            <ContactStep2 values={this.state} onChange={this.onChange} />
          )}
          {step === 3 && (
            <ContactStep3
              values={this.state}
              closeModal={
                this.props.hideModalContact || this.context.hideModalContact
              }
            />
          )}
          {step !== 3 && (
            <div className="form-desc">
              <button
                className="btn-general btn-general--primary"
                onClick={this.nextStep}
                disabled={!this.state.checkbox}
              >
                Dalej
              </button>
              <input
                type="checkbox"
                id="checkbox-stream-6"
                value={this.state.checkbox}
                onClick={e => {
                  this.setState({
                    checkbox: e.target.checked
                  });
                }}
              />
              <label htmlFor="checkbox-stream-6" className="checkbox">
                Wyrażam zgodę na przetwarzanie danych osobowych zgodnie z ustawą
                o ochronie danych osobowych w związku z wysłanie zapytania przez
                formularz kontaktowy. Podanie danych jest dobrowolne, ale
                niezbędne do przetworzenia zapytania. Zostałem poinformowany, że
                przysługuje mi prawo dostępu do swoich danych osobowych,
                możliwości ich poprawiania, żądania zaprzestania ich
                przetwarzania.
              </label>
            </div>
          )}
        </ModalWrapperBorder>
      </ContactWrapperStyle>
    );
  }
}

ContactWrapper.contextType = ThemeContext;

export default ContactWrapper;
